import { Component, input, model } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxOptional } from '../../../interfaces';
import { I18N_NAMESPACE } from '../../../internal/constants';
import { OnyxButtonComponent } from '../../buttons/onyx-button/onyx-button.component';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';

@Component({
  selector: 'onyx-loading-error',
  imports: [OnyxIconComponent, OnyxButtonComponent, TranslatePipe],
  templateUrl: './onyx-loading-error.component.html',
  styleUrl: './onyx-loading-error.component.scss',
})
export class OnyxLoadingErrorComponent {
  public readonly message = input<OnyxOptional<string>>();
  public readonly error = model.required<boolean>();

  protected readonly I18N = `${I18N_NAMESPACE}.error`;
}
